var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[(_vm.moduleData.ready)?_c('module',{attrs:{"routeData":_vm.moduleData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }